import {Provider} from 'react-redux';
import App from './qep-prefs.js';
import {store} from './store/index.js';

const QepUserPreferences = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default QepUserPreferences;
